import * as React from 'react'
import { Alert, Card, Descriptions, Space, Spin } from 'antd'
import { ChangeAmountsModal } from '../changeAmountsModal/component'
import { DepositEdit } from '../../edit/types'

type Props = {
  deposit: DepositEdit
  loading: boolean
  error: { message: string }
  success: { message: string }
}

export const DepositAmountsBlock = ({
  deposit,
  loading,
  error,
  success,
}: Props) => (
  <Card size="small" title="Amounts">
    {loading ? (
      <Spin />
    ) : (
      <Descriptions size="small" column={3} bordered>
        <Descriptions.Item label="Initial amount">
          {deposit.initialAmount} {deposit.initialCurrency}
        </Descriptions.Item>
        <Descriptions.Item label="Client amount">
          {deposit.clientAmount} {deposit.clientCurrency}
        </Descriptions.Item>
        <Descriptions.Item label="Company amount">
          {deposit.companyAmount} {deposit.companyCurrency}
        </Descriptions.Item>
      </Descriptions>
    )}

    <Space direction="vertical" style={{ width: '100%', marginTop: 12 }}>
      <ChangeAmountsModal disabled={loading} />
      {error.message.length > 0 && (
        <Alert type="error" message={`Error code: ${error.message}`} />
      )}
      {success.message.length > 0 && (
        <Alert type="success" message={success.message} />
      )}
    </Space>
  </Card>
)
